import wmsCnRequest from '@alife/cnc-cn-request-wms';

import { cnRequest } from './request';

window.wmsCnRequest = wmsCnRequest;

export default cnRequest;
